const productDetailsInfo = {}

export default {
  productDetailsInfo
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/payment-details/store/state.js